import FastClick from 'fastclick/lib/fastclick'

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    FastClick.attach(document.body)
  }, false)
}

(function () {
  if ($(".js-modal-video").length && typeof $(".js-modal-video").modalVideo === 'function') { 
    $(".js-modal-video").modalVideo({
      channel: "youtube",
      youtube: {
        rel: 0, //関連動画の指定
        autoplay: 0, //自動再生の指定
        controls: 1, //コントロールさせるかどうかの指定
      },
    });
  }

  if (typeof Zooming === 'function' && $('[data-action="zoom"], .news__detail__content img').length) {
    new Zooming().listen('[data-action="zoom"], .news__detail__content img');
  }

  $('#form').validate({
      // Validationルール
      rules: {
        type: {
          required: true, 
        },
        affiliation: {
          required: true, 
        },
        name: {
          required: true, 
        },
        email: {
          required: true, 
          email: true
        },
        tel: {
          required: true, 
        },
        contents: {
          required: true, 
        },
        'policy': {
          required: true
        },
      },

      // エラーメッセージ
      messages: {
        type: {
          required: '選択してください',
        },
        affiliation: {
          required: '入力してください',
        },
        name: {
          required: '入力してください',
        },
        email: {
          required: '入力してください',
          email: '形式が間違っています'
        },
        tel: {
          required: '入力してください',
        },
        contents: {
          required: '内容を入力してください', 
        },
        'policy': {
          required: 'プライバシーポリシーに同意の上チェックしてください'
        },
      },

      // エラーメッセージ出力箇所
      errorPlacement: function(error, element){
          var name = element.attr('name');
          if (element.is(':radio, :checkbox')) {
            error.appendTo(element.parents('.form__checkbox__wrapper').find('.is-error-'+name));
          } else {
            error.appendTo($('.is-error-'+name));
          }
      },

      errorElement: "span",
      errorClass: "is-error",
  });
  
  $('#reEdit').on('click', function () {
    if ( $(this).text() === '修正する' ) {
      $(this).text('もとに戻す')
    } else {
      $('#confirm')[0].reset()
      $(this).text('修正する')
    }
    $('#confirm .-readonly').each(function (i, ele) {
      $(ele).toggleClass('-edit');
      $(ele).find('[readonly]').each(function (j, input) {
        $(input).attr('readonly', !$(input).attr('readonly'));
      });
    });
  });

  $('#confirm').validate({
      // Validationルール
      rules: {
        type: {
          required: true, 
        },
        affiliation: {
          required: true, 
        },
        name: {
          required: true, 
        },
        email: {
          required: true, 
          email: true
        },
        tel: {
          required: true, 
        },
        contents: {
          required: true, 
        },
        'policy': {
          required: true
        },
      },

      // エラーメッセージ
      messages: {
        type: {
          required: '選択してください',
        },
        affiliation: {
          required: '入力してください',
        },
        name: {
          required: '入力してください',
        },
        email: {
          required: '入力してください',
          email: '形式が間違っています'
        },
        tel: {
          required: '入力してください',
        },
        contents: {
          required: '内容を入力してください', 
        },
        'policy': {
          required: 'プライバシーポリシーに同意の上チェックしてください'
        },
      },

      // エラーメッセージ出力箇所
      errorPlacement: function(error, element){
          var name = element.attr('name');
          if (element.is(':radio, :checkbox')) {
            error.appendTo(element.parents('.form__checkbox__wrapper').find('.is-error-'+name));
          } else {
            error.appendTo($('.is-error-'+name));
          }
      },

      errorElement: "span",
      errorClass: "is-error",
  });
})();